import React from "react"
import styled from "styled-components"
import { Link, useIntl } from "gatsby-plugin-react-intl"

import Layout from "../layouts/Layout"
import { Container, Row, Col } from "../components/Grid"
import Button from "../components/Button"
import Seo from "../components/Seo"

import { media, mixins } from "../styles"

import pageMissingIllustration from "../images/illustrations/404.svg"

const Wrapper = styled.div`
  text-align: center;
  padding: 45px 0 65px;
  position: relative;

  @media ${media.md} {
    background: ${({ theme }) => theme.greyLight};
    text-align: left;
    min-height: 400px;
    margin: 0 0 20px;
  }

  @media ${media.lg} {
    min-height: 540px;
    padding: 60px 0 65px;
  }

  @media ${media.xl} {
    min-height: 700px;
    padding: 90px 0 65px;
  }
`

const Header = styled.div`
  margin: 0 0 15px;
  padding: 0 30px;

  @media ${media.md} {
    padding: 0;
    margin: 0 0 50px;
  }

  h1 {
    ${mixins.title5}
    margin: 0 0 15px;
  }

  h2 {
    ${mixins.title3}
    margin: 0;
  }
`

const Illustration = styled.div`
  margin: 0 auto 50px;
  width: 260px;

  @media ${media.md} {
    position: absolute;
    left: calc(100% + 20px);
    top: 0;
    width: 300px;
  }

  @media ${media.lg} {
    width: 100%;
  }

  img {
    height: auto;
    max-width: 100%;
  }
`

const Background = styled.div`
  height: 380px;
  background: ${({ theme }) => theme.greyLight};
  position: absolute;
  width: 100%;
  top: 0;
  left: 0;
  right: 0;
  overflow: hidden;
  z-index: -1;

  @media ${media.lg} {
    display: none;
    height: 470px;
  }

  @media ${media.xl} {
    height: 640px;
  }
`

const NotFoundPage = () => {
  const intl = useIntl()
  const homeLink = "/"

  return (
    <Layout pageId="404">
      <Seo title={intl.formatMessage({ id: "notfound.subHeader" })} />
      <Container>
        <Wrapper>
          <Row>
            <Col md="5" mdOffset="1">
              <Header>
                <h1>{intl.formatMessage({ id: "notfound.subHeader" })}</h1>
                <h2>{intl.formatMessage({ id: "notfound.header" })}</h2>
              </Header>
              <Illustration>
                <img
                  alt="404"
                  src={pageMissingIllustration}
                  width="524"
                  height="520"
                />
              </Illustration>
              <Button as={Link} to={homeLink} arrow>
                {intl.formatMessage({ id: "notfound.linkText" })}
              </Button>
            </Col>
          </Row>
          <Background />
        </Wrapper>
      </Container>
    </Layout>
  )
}

export default NotFoundPage
